
$(document).ready(function() {

  // MENU MOBILE
  $('.menu_nav').click(function () {
    $(this).toggleClass('opened');
    $('nav').toggleClass('opened');
    $('body').toggleClass('overflow');
    $('html').toggleClass('overflow');
  });
  $('nav li a').click(function () {
    $('.menu_nav').removeClass('opened');
    $('nav').removeClass('opened');
    $('body').removeClass('overflow');
    $('html').css('overflow','auto');
  });

  // SLIDESHOW
  $('.slider_hero').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          arrows: false
        }
      }
    ]
  });
  $('.slider_blog-hero').slick({ 
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          arrows: false,  
          dots: true
        }
      }
    ]
  });
  $('.slider_projects').slick({
    slidesToShow: 2,
    arrows: true,
    dots: true,
    infinite: false, 
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.slider_team').slick({
    slidesToShow: 4,
    arrows: false,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  }); 
  $('.slider_partners').slick({
    slidesToShow: 6,
    slidesToScroll: 6,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false
        }
      }
    ]
  });
  $('.slider_blog').slick({
    slidesToShow: 3,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });
  $('.slider_benefits').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: false,
    fade: true,
    swipe: false
  });
  $('.slider_methodologies').slick({
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: false,
        }
      },
    ]
  });
  $('.slider_importance').slick({
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: 'unslick'
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        }
      },
    ]
  });
  $('.slider_wyacademy-1').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        }
      }
    ]
  });
  $('.slider_wyacademy-2').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false
        }
      },
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
        }
      }
    ]
  });

  $(".tab_section .tab_link").on("click", (function(e)
    {
      e.preventDefault(); var slideIndex = $(this).index();
      console.log(slideIndex);
      $( '.slider_benefits' ).slick('slickGoTo', slideIndex, false);
    }
  ));

  // HEIGHT EQUAL WIDTH MOBILE
  if ( $(window).width() < 768 ) {
    var itemWidth = $('.square').width(); 
    $('.square').height(itemWidth);
  }

  // IN VIEWPORT
  $(function($, win) {
    $.fn.inViewport = function(cb) {
      return this.each(function(i,el){
        function visPx(){
          var H = $(this).height(),
              r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
          return cb.call(el, Math.max(0, t>0? H-t : (b<H?b:H)));  
        } visPx();
        $(win).on("resize scroll", visPx);
      });
    };
  }(jQuery, window));
      
  // COUNT NUMBERS ANIMATION
  jQuery(function($) {
    $(".stat").inViewport(function(px) {
      if(px>0 && !this.initNumAnim) { 
        this.initNumAnim = true;
        $(this).prop('Counter',0).animate({
          Counter: $(this).text()
        }, {
          duration: 2000,
          step: function (now) {
            $(this).text(parseFloat(now.toFixed(0)));
          }
        });         
      }
    });
  }); 

  // TABS
  $('ul.tabs li').click(function () {
    var tab_id = $(this).attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $('.tab_content').removeClass('current');
    $(this).addClass('current');
    $("#" + tab_id).addClass('current');
    $('.slider_partners').slick('refresh');
  });
  $('.section_impacto-wylinka-a ul.tabs li:first').addClass('current');

  // ANIMATION ON SCROLL
  $('.animate__animated').scrollClass({
    delay: 20
  });

	// MODAL
	$('.open-modal').click(function(e){
	  $('.modal').show();
	  $('body').css('overflow-y','hidden');
    $('.infos').empty();
    $('.loading').addClass('show')
    $('.linkedin').hide();
    var data = {
      'action': 'load_post_by_ajax',
      'id': $(this).data('id'),
      'security': blog.security,
    };
    $.post(blog.ajaxurl, data, function(response) {
      response = JSON.parse(response);
      $('.loading').removeClass('show');
      $('.linkedin').show();
      $('#modal-team .name').text(response.title);
      $('#modal-team .role').text(response.role);
      $('#modal-team .content').html(response.content);
      $('#modal-team .linkedin').attr('href',response.linkedin);
      $(".linkedin").each(function (i) {
        var aHref = $(this).attr('href');
        if (aHref == '' || !aHref) { 
          $(this).hide();
        } else {
          $(this).show();
        };
      });
	  });
    $('.close').click(function(){
      $('.modal').hide();
      $('body').css('overflow-y','visible');
    })
    var KEYCODE_ESC = 27;
    $(document).keyup(function (e) {
      if (e.keyCode == KEYCODE_ESC) {
        $('.modal').hide();
        $('body').css('overflow-y','visible');
      }
    });
  });

  // -- SELECT CATEGORIES  ------------------------------------------------ //
  // $('#category-select').change(function() {
  // location.reload();
  //  var id = $(this).val();
  //  $('.category_item').removeClass('inactive active');
  //  $('.category_item:not(.category_' + id + ')').addClass('inactive')
  //  $('.category_item.category_' + id).addClass('active');
  // });
  
});